// ID des angemeldeten Nutzers (für created_by / erfasst_von in bestehenden Formularen).

import { useEffect, useState } from 'react';
import { supabase } from '../supabase/client';

export function useNutzerId(): string | null {
  const [id, setId] = useState<string | null>(null);
  useEffect(() => {
    let aktiv = true;
    supabase.auth.getSession().then(({ data }) => { if (aktiv) setId(data.session?.user.id ?? null); }).catch(() => {});
    return () => { aktiv = false; };
  }, []);
  return id;
}
